/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_FailureInputs */

const tr_geliver_status_failure = /** @type {(inputs: Geliver_Status_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim edilemedi`)
};

const en_geliver_status_failure = /** @type {(inputs: Geliver_Status_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery failed`)
};

const de_geliver_status_failure = /** @type {(inputs: Geliver_Status_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustellung fehlgeschlagen`)
};

const ru_geliver_status_failure = /** @type {(inputs: Geliver_Status_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка не удалась`)
};

/**
* | output |
* | --- |
* | "Delivery failed" |
*
* @param {Geliver_Status_FailureInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_failure = /** @type {((inputs?: Geliver_Status_FailureInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_FailureInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_failure(inputs)
	if (locale === "de") return de_geliver_status_failure(inputs)
	if (locale === "ru") return ru_geliver_status_failure(inputs)
	return tr_geliver_status_failure(inputs)
});